/**
 * /frontend/src/features/analytics/api/anomalyAnalyticsApi.js
 */

import { ANALYTICS_ENDPOINTS } from '../constants/analyticsEndpoints';
import { getJson } from './analyticsApiClient';

/**
 * Fetches active anomalies.
 */
export const getActiveAnomalies = async (request, token, storeId) => getJson(
  request,
  ANALYTICS_ENDPOINTS.ANOMALIES_ACTIVE,
  { storeId },
  token,
  'analytics-anomalies-active'
);

/**
 * Fetches anomaly history.
 */
export const getAnomalyHistory = async (request, token, storeId, startDate, endDate) => getJson(
  request,
  ANALYTICS_ENDPOINTS.ANOMALIES_HISTORY,
  { storeId, startDate, endDate },
  token,
  'analytics-anomalies-history'
);

